import {MODAL_DATA_SET, MODAL_DATA_REMOVE} from '../actions';
import {ActionWithPayload} from './index';
import {AppState} from "@store/reducers/index";

export interface ModalState {
  bodyModalText?: string;
  bodyText?: string;
  errorType?: {
    dimensions: boolean,
    route: boolean,
  };
  error?: boolean;
  id?: string;
  header?: string;
  removeShow?: boolean;
  showCancel?: boolean;
  showOk?: boolean;
  showModal?: boolean;
}

export function modalReducer (
  state = {
    bodyModalText: null,
    bodyText: null,
    errorType:  null,
    error: false,
    id: null,
    header: null,
    removeShow: false,
    showCancel: false,
    showOk: false,
    showModal: false,
  }, action: ActionWithPayload<ModalState>) {
  switch (action.type) {
    case MODAL_DATA_SET:
      return {
        ...action.payload,
        showModal: true,
      };
    case MODAL_DATA_REMOVE:
      return {
        bodyModalText: null,
        bodyText: null,
        errorType:  null,
        error: false,
        id: null,
        header: null,
        removeShow: false,
        showCancel: false,
        showOk: false,
        showModal: false,
      };

    default:
      return state;
  }
}

export const selectModal = (state: AppState) => state.modal;



// WEBPACK FOOTER //
// ./src/app/store/reducers/modal.reducer.ts